/**
 * Resolves a partial image path from the backend into a full URL.
 * Handles:
 * 1. Missing paths (returns placeholder)
 * 2. Already full URLs (http/https)
 * 3. Relative paths missing /uploads prefix
 * 4. Development vs Production origins
 */
export const getFullImageUrl = (path) => {
    if (!path) return 'https://via.placeholder.com/600x400?text=Alrehima';
    
    // If it's already a full URL, return it
    if (path.startsWith('http')) return path;
    
    // Get Base URL for Assets
    // In production, assets are served from the root domain.
    // In development, they are served from the backend dev server.
    const assetBase = process.env.NODE_ENV === 'production' 
        ? window.location.origin 
        : 'http://localhost:5000';
    
    // Clean up the path (ensure single slash at start)
    let cleanPath = path.startsWith('/') ? path : '/' + path;
    
    // Specific check for system category images (hadith.png, fiqh.png, etc.)
    // These are known to be in the /uploads/ root folder on the server
    const systemImages = ['hadith.png', 'fiqh.png', 'seerah.png', 'adhkar.png', 'quran.png'];
    const fileName = cleanPath.split('/').pop();
    
    if (systemImages.includes(fileName) && !cleanPath.includes('/uploads/')) {
        cleanPath = '/uploads' + cleanPath;
    }
    
    // If it's a relative path that doesn't start with /uploads, prepend /uploads 
    if (!cleanPath.startsWith('/uploads/')) {
        cleanPath = '/uploads' + cleanPath;
    }
    
    // Construct final URL
    return assetBase.replace(/\/$/, '') + cleanPath;
};
